import {
	FETCH_INTERVIEW_CATEGORIES_SUCCESS,
	FETCH_INTERVIEW_CATEGORY_BY_ID_SUCCESS,
	INTERVIEW_CATEGORIES_REQUEST_LOADING,
	INTERVIEW_CATEGORIES_REQUEST_ERRORS
} from "api/menu/hr/interview-categories/actions";

const initialState = {
	loading: false,
	errors: [],
	categories: [],
	singleCategory: {}
};

export default function(state = initialState, action) {
	switch (action.type) {
		case INTERVIEW_CATEGORIES_REQUEST_LOADING:
			return { ...state, loading: true };
		case INTERVIEW_CATEGORIES_REQUEST_ERRORS:
			return { ...state, loading: false, errors: action.payload };
		case FETCH_INTERVIEW_CATEGORIES_SUCCESS:
			return { ...state, loading: false, categories: action.payload };
		case FETCH_INTERVIEW_CATEGORY_BY_ID_SUCCESS:
			return { ...state, loading: false, singleCategory: action.payload };
		default:
			return state;
	}
}
